import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { getAllBlogPosts, BlogPost } from '../data/blogData'
import './BlogList.css'

const BlogList: React.FC = () => {
  const [posts, setPosts] = useState<BlogPost[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const loadPosts = async () => {
      try {
        const blogPosts = await getAllBlogPosts()
        console.log('Posts loaded:', blogPosts)
        setPosts(blogPosts)
      } catch (error) {
        console.error('Error loading blog posts:', error)
      } finally {
        setLoading(false)
      }
    }

    loadPosts()
  }, [])

  if (loading) {
    return (
      <div className="blog-list-container">
        <div className="blog-loading">
          <p>Loading blog posts...</p>
        </div>
      </div>
    )
  }

  if (posts.length === 0) {
    return (
      <div className="blog-list-container">
        <div className="blog-empty">
          <h2>No blog posts yet</h2>
          <p>Check back soon for new content!</p>
        </div>
      </div>
    )
  }

  return (
    <div className="blog-list-container">
      <div className="blog-header">
        <h1>Blog</h1>
        <p>Thoughts, tutorials, and insights about development and technology</p>
      </div>

      <ul className="blog-list">
        {posts.map((post) => (
          <li key={post.id} className="blog-list-item">
            <div className="blog-item-header">
              <h2 className="blog-item-title">
                <Link to={`/blog/${post.slug}`}>{post.title}</Link>
              </h2>
              <div className="blog-meta">
                <time dateTime={post.date}>
                  {new Date(post.date).toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric'
                  })}
                </time>
                <span className="blog-read-time">{post.readTime}</span>
              </div>
            </div>

            <p className="blog-item-excerpt">{post.excerpt}</p>

            {post.tags && post.tags.length > 0 && (
              <div className="blog-tags">
                {post.tags.map((tag) => (
                  <span key={tag} className="blog-tag">
                    #{tag}
                  </span>
                ))}
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default BlogList